/*jshint esversion: 6 */

import Vue from 'Vue';

export default new Vue;


// WEBPACK FOOTER //
// ./src/js/eventBus.js